<template>
  <div class="progress_wrapper">
    <div
      :class="progressColor"
      :style="{ width: circleSize, height: circleSize }"
    >
      <div
        class="progress_inner"
        :style="{ width: circleSize, height: circleSize }"
      >
        <div class="inner" :style="innerStyle">
          <div
            class="percent"
            :style="{
              color: waterColor,
              fontSize: textSize,
              lineHeight: circleSize,
            }"
          >
            {{ roundedPercent }}
            <small>%</small>
          </div>
          <div class="water" :style="waterStyle"></div>
          <div class="glare"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    percent: {
      type: Number,
      default: 0,
    },
    size: {
      type: String,
      default: "md",
    },
  },
  data() {
    return {
      levelColors: ["#d63031", "#fdcb6e", "#00b894"],
    };
  },
  computed: {
    roundedPercent() {
      return Math.round(this.percent); // Redondear el porcentaje
    },
    circleSize() {
      return `${this.sizeProgress}px`;
    },
    borderSize() {
      return `${Math.max(this.sizeProgress / 50, this.size == "xs" ? 2 : 3)}px`;
    },
    waterLevel() {
      return `${100 - this.roundedPercent}%`;
    },
    waterColor() {
      const val = this.roundedPercent;
      const colorInc = 100 / 3;
      if (val < colorInc) return this.levelColors[0]; // Bajo
      if (val < colorInc * 2) return this.levelColors[1]; // Medio
      return this.levelColors[2]; // Alto
    },
    progressColor() {
      return {
        borderColor: this.waterColor,
      };
    },
    waterStyle() {
      return {
        top: this.waterLevel,
        backgroundColor: this.waterColor,
        borderColor: this.waterColor,
        width: "200%",
        height: "200%",
        left: "-50%",
        borderRadius: "40%",
      };
    },
    innerStyle() {
      return {
        borderColor: this.waterColor,
        borderWidth: this.borderSize,
        width: "90%",
        height: "90%",
        top: "5%",
        left: "5%",
      };
    },
    textSize() {
      let size = "";
      switch (this.size) {
        case "xs":
          size = "12";
          break;
        case "sm":
          size = "15";
          break;
        case "md":
          size = "20";
          break;
        case "lg":
          size = "25";
          break;
        case "xl":
          size = "30";
          break;
      }
      return `${Math.max(this.sizeProgress / 5, size)}px`;
    },
    sizeProgress() {
      let size = "";
      switch (this.size) {
        case "xs":
          size = "40";
          break;
        case "sm":
          size = "50";
          break;
        case "md":
          size = "70";
          break;
        case "lg":
          size = "80";
          break;
        case "xl":
          size = "90";
          break;
      }

      return size;
    },
  },
};
</script>

<style scoped>
@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.progress_wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  z-index: 1;
}

.progress_inner {
  position: relative;
  border-radius: 50%;
}

.inner {
  position: absolute;
  overflow: hidden;
  z-index: 2;
  border-radius: 50%;
  border-style: solid;
  transition: border-color 1s ease, border-width 1s ease;
}

.water {
  position: absolute;
  z-index: 1;
  animation: spin 10s linear infinite;
  transition: all 1s ease;
  opacity: 0.6;
}

.glare {
  position: absolute;
  top: -120%;
  left: -120%;
  z-index: 5;
  width: 200%;
  height: 200%;
  transform: rotate(45deg);
  border-radius: 50%;
  transition: all 1s ease;
}

.percent {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  text-align: center;
  transition: color 1s ease;
}
</style>
